// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M17.5 21H11V19H18.7227L17.5 21Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M9 21H6.5L5.27734 19H9V21Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M17 17H9V15H17V17Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M19.9443 17H19V15H21.167L19.9443 17Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M7 17H4.05566L2.83301 15H7V17Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M23 12L22.3887 13H14V11H22.3887L23 12Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M12 13H1.61133L1 12L1.61133 11H12V13Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M21.167 9H2.83301L4.05566 7H19.9443L21.167 9Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M18.7227 5H16V3H17.5L18.7227 5Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M14 5H5.27734L6.5 3H14V5Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-logo-tencentcode')
export default class LogoTencentcodeIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'logo-tencentcode',
    }
  }
}
